// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1LCNh","col":"Table_col__2sYHl","fulfillmentStatus":"Table_fulfillmentStatus__3ZYrK","emailCol":"Table_emailCol__1cVdM"};